const COMMUNITIES_CACHE_KEY = 'communitiesCache';

export function loadCommunitiesFromCache() {
    try {
        const raw = localStorage.getItem(COMMUNITIES_CACHE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
        return [];
    }
}

export function saveCommunitiesToCache(communities) {
    try {
        if (!Array.isArray(communities)) return;
        localStorage.setItem(COMMUNITIES_CACHE_KEY, JSON.stringify(communities));
    } catch (e) {
        // ignore write errors
    }
}


